<section
  class="bn-unlinked-outcomes"
  aria-label="Unlinked outcomes"
  [attr.aria-busy]="store().loading() || modal.opening()"
>
  @if (store().loading()) {
    <div role="status" aria-label="Loading unlinked outcomes">
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
      <p-skeleton height="6.25rem" borderRadius="0.75rem" styleClass="mt-3" />
    </div>
  } @else if (store().error(); as error) {
    <div role="alert">
      <p>{{ error }}</p>
      <button type="button" (click)="store().load()">Retry outcomes</button>
    </div>
  } @else {
    @if (store().referenceError(); as error) {
      <div role="alert">
        <p>{{ error }}</p>
        <button type="button" (click)="store().loadReferences(true)">
          Retry outcome choices
        </button>
      </div>
    }
    @if (modal.error(); as error) {
      <div role="alert">
        <p>{{ error }}</p>
        <button type="button" (click)="store().load()">Refresh outcomes</button>
      </div>
    }
    @if (store().outcomes().length === 0) {
      <p role="status">No unlinked outcomes.</p>
    } @else {
      @for (outcome of store().outcomes(); track outcome.outcomeId) {
        <bn-outcome-card
          [outcome]="outcome"
          [typeLabel]="store().label(outcome.outcomeTypeCode)"
          [editable]="store().canEdit(outcome)"
          [disabled]="modal.opening()"
          (openOutcome)="modal.open(store(), $event)"
        />
      }
    }
  }
</section>
